import React from "react";

export function Analysis(){
    return(
        <div>
            <h1>Análises das Empresas</h1>
        </div>
    )
}